function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M122 204C189.379 204 244 196.613 244 187.5V169.5C244 178.613 189.379 186 122 186C54.6213 186 0 178.613 0 169.5V187.5C0 196.613 54.6213 204 122 204Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M122 204C189.379 204 244 196.613 244 187.5V169.5H122H0V187.5C0 196.613 54.6213 204 122 204Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 169.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 169.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint1_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M122 186C189.379 186 244 178.613 244 169.5C244 169.5 244 168.5 243.5 168.5C238.5 173 224.144 176.187 192 179C155 182.237 113.5 182.864 72.5 181C59.3234 180.401 6.5 176.5 0.500003 168C0 169 0 169.5 0 169.5C0 178.613 54.6213 186 122 186Z",
  fill: "url(#paint2_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M128 182C195.379 182 250 174.613 250 165.5V147.5C250 156.613 195.379 164 128 164C60.6213 164 6 156.613 6 147.5V165.5C6 174.613 60.6213 182 128 182Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M128 182C195.379 182 250 174.613 250 165.5V147.5H128H6V165.5C6 174.613 60.6213 182 128 182Z",
  fill: "url(#paint3_linear)",
  fillOpacity: 0.25
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 147.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 147.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint4_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M128 164C195.379 164 250 156.613 250 147.5C250 147.5 250 146.5 249.5 146.5C244.5 151 230.144 154.187 198 157C161 160.237 119.5 160.864 78.5 159C65.3234 158.401 12.5 154.5 6.5 146C6 147 6 147.5 6 147.5C6 156.613 60.6213 164 128 164Z",
  fill: "url(#paint5_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M124 159C191.379 159 246 151.613 246 142.5V124.5C246 133.613 191.379 141 124 141C56.6213 141 2 133.613 2 124.5V142.5C2 151.613 56.6213 159 124 159Z",
  fill: "currentColor"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M124 159C191.379 159 246 151.613 246 142.5V124.5H124H2V142.5C2 151.613 56.6213 159 124 159Z",
  fill: "url(#paint6_linear)",
  fillOpacity: 0.25
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 124.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 124.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint7_linear)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M124 141C191.379 141 246 133.613 246 124.5C246 124.5 246 123.5 245.5 123.5C240.5 128 226.144 131.187 194 134C157 137.237 115.5 137.864 74.5 136C61.3234 135.401 8.5 131.5 2.5 123C2 124 2 124.5 2 124.5C2 133.613 56.6213 141 124 141Z",
  fill: "url(#paint8_linear)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M127 137C194.379 137 249 129.613 249 120.5V102.5C249 111.613 194.379 119 127 119C59.6213 119 5 111.613 5 102.5V120.5C5 129.613 59.6213 137 127 137Z",
  fill: "currentColor"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M127 137C194.379 137 249 129.613 249 120.5V102.5H127H5V120.5C5 129.613 59.6213 137 127 137Z",
  fill: "url(#paint9_linear)",
  fillOpacity: 0.25
});

var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 102.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 102.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint10_linear)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M127 119C194.379 119 249 111.613 249 102.5C249 102.5 249 101.5 248.5 101.5C243.5 106 229.144 109.187 197 112C160 115.237 118.5 115.864 77.5 114C64.3234 113.401 11.5 109.5 5.5 101C5 102 5 102.5 5 102.5C5 111.613 59.6213 119 127 119Z",
  fill: "url(#paint11_linear)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M131 112C198.379 112 253 104.613 253 95.4999V77.5C253 86.6127 198.379 94 131 94C63.6213 94 9 86.6127 9 77.5V95.4999C9 104.613 63.6213 112 131 112Z",
  fill: "currentColor"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M131 112C198.379 112 253 104.613 253 95.4999V77.5H131H9V95.4999C9 104.613 63.6213 112 131 112Z",
  fill: "url(#paint12_linear)",
  fillOpacity: 0.25
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 131,
  cy: 77.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 131,
  cy: 77.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint13_linear)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M131 94C198.379 94 253 86.6127 253 77.5C253 77.5 253 76.5 252.5 76.5C247.5 81 233.144 84.1874 201 87C164 90.2375 122.5 90.8636 81.5 89C68.3234 88.401 15.5 84.5 9.5 76C9 77 9 77.5 9 77.5C9 86.6127 63.6213 94 131 94Z",
  fill: "url(#paint14_linear)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M122 89.9999C189.379 89.9999 244 82.6126 244 73.4999V55.5C244 64.6127 189.379 72 122 72C54.6213 72 0 64.6127 0 55.5V73.4999C0 82.6126 54.6213 89.9999 122 89.9999Z",
  fill: "currentColor"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M122 89.9999C189.379 89.9999 244 82.6126 244 73.4999V55.5H122H0V73.4999C0 82.6126 54.6213 89.9999 122 89.9999Z",
  fill: "url(#paint15_linear)",
  fillOpacity: 0.25
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 55.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref30 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 55.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint16_linear)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M122 72C189.379 72 244 64.6127 244 55.5C244 55.5 244 54.5 243.5 54.5C238.5 59 224.144 62.1874 192 65C155 68.2375 113.5 68.8636 72.5 67C59.3234 66.401 6.5 62.5 0.500003 54C0 55 0 55.5 0 55.5C0 64.6127 54.6213 72 122 72Z",
  fill: "url(#paint17_linear)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M132 70.9999C199.379 70.9999 254 63.6126 254 54.4999V36.5C254 45.6127 199.379 53 132 53C64.6213 53 10 45.6127 10 36.5V54.4999C10 63.6126 64.6213 70.9999 132 70.9999Z",
  fill: "currentColor"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M132 70.9999C199.379 70.9999 254 63.6126 254 54.4999V36.5H132H10V54.4999C10 63.6126 64.6213 70.9999 132 70.9999Z",
  fill: "url(#paint18_linear)",
  fillOpacity: 0.25
});

var _ref34 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 132,
  cy: 36.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref35 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 132,
  cy: 36.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint19_linear)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M132 53C199.379 53 254 45.6127 254 36.5C254 36.5 254 35.5 253.5 35.5C248.5 40 234.144 43.1874 202 46C165 49.2375 123.5 49.8636 82.5 48C69.3234 47.401 16.5 43.5 10.5 35C10 36 10 36.5 10 36.5C10 45.6127 64.6213 53 132 53Z",
  fill: "url(#paint20_linear)"
});

var _ref37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 244,
  y1: 204,
  x2: 118,
  y2: 204,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 137,
  y1: 158,
  x2: 122,
  y2: 180,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: -3.63368e-8,
  y1: 186,
  x2: 244,
  y2: 186,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 250,
  y1: 182,
  x2: 124,
  y2: 182,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 143,
  y1: 136,
  x2: 128,
  y2: 158,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 6,
  y1: 164,
  x2: 250,
  y2: 164,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 246,
  y1: 159,
  x2: 120,
  y2: 159,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 139,
  y1: 113,
  x2: 124,
  y2: 135,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 2,
  y1: 141,
  x2: 246,
  y2: 141,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 249,
  y1: 137,
  x2: 123,
  y2: 137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 142,
  y1: 91,
  x2: 127,
  y2: 113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 5,
  y1: 119,
  x2: 249,
  y2: 119,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 253,
  y1: 112,
  x2: 127,
  y2: 112,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 146,
  y1: 66,
  x2: 131,
  y2: 88,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 9,
  y1: 93.9999,
  x2: 253,
  y2: 93.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 244,
  y1: 90,
  x2: 118,
  y2: 90,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 137,
  y1: 44,
  x2: 122,
  y2: 66,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: -3.63368e-8,
  y1: 71.9999,
  x2: 244,
  y2: 71.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear",
  x1: 254,
  y1: 71,
  x2: 128,
  y2: 71,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear",
  x1: 147,
  y1: 25,
  x2: 132,
  y2: 47,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear",
  x1: 10,
  y1: 52.9999,
  x2: 254,
  y2: 52.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})));

function Svg7Chip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 212,
    viewBox: "0 0 259 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7Chip);
export default __webpack_public_path__ + "static/media/7chip.2e6ad621.svg";
export { ForwardRef as ReactComponent };